import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

const PERKS = [
  { ic: "💰", h: "Earn coins & gifts", p: "Get rewarded for every meaningful conversation. Coins convert to real earnings, paid out reliably." },
  { ic: "📈", h: "Grow your audience", p: "Reach our community of people looking to learn and connect. Build a following that's genuinely yours." },
  { ic: "🕒", h: "Flexible hours", p: "Coach whenever you want, from wherever you are. No fixed schedule — your time, your terms." },
];

const STEPS = [
  { n: "01", h: "Apply", p: "Fill out the form with your details and a little about why you'd be a great coach." },
  { n: "02", h: "Get verified", p: "Our team reviews your application and reaches out within 24 hours for the next steps." },
  { n: "03", h: "Start coaching", p: "Download the app, set up your profile, and start guiding people one conversation at a time." },
];

export default function ConversationCoach() {
  return (
    <>
      <Helmet>
        <title>Become a Conversation Coach — Instafrnd</title>
        <meta name="description" content="Earn coins and grow your audience as a Conversation Coach on Instafrnd. Teach languages, skills, and more — on your own schedule." />
        <link rel="canonical" href="https://instafrnd.com/become-a-coach" />
        <meta property="og:url" content="https://instafrnd.com/become-a-coach" />
        <meta property="og:title" content="Become a Conversation Coach — Instafrnd" />
        <meta property="og:description" content="Earn coins and grow your audience as a Conversation Coach on Instafrnd. Teach languages, skills, and more — on your own schedule." />
      </Helmet>
      <PageHero
        eyebrow="Become a Conversation Coach"
        title="Turn great conversations into a career."
        subtitle="Guide our community on confidence, communication, and connection — and get rewarded for the impact you make."
      />

      <section className="section-pad">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">Why coach with us</div>
            <h2>Do what you love. Get rewarded.</h2>
          </div>
          <div className="card-grid">
            {PERKS.map((p, k) => (
              <div className="info-card reveal" key={k} style={{ transitionDelay: `${k * 0.08}s` }}>
                <div className="ic">{p.ic}</div>
                <h3>{p.h}</h3>
                <p>{p.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="features">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">What we look for</div>
            <h2>Three things make a great coach.</h2>
          </div>
          <div className="card-grid">
            <div className="info-card reveal"><div className="ic">💬</div><h3>Engaging communication</h3><p>You're warm, articulate, and genuinely enjoy talking with new people.</p></div>
            <div className="info-card reveal" style={{ transitionDelay: ".08s" }}><div className="ic">❤️</div><h3>Empathy &amp; patience</h3><p>You listen well and create a safe, judgment-free space for others to open up.</p></div>
            <div className="info-card reveal" style={{ transitionDelay: ".16s" }}><div className="ic">⚡</div><h3>Enthusiasm</h3><p>You bring positive energy and want to help people become their best selves.</p></div>
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">How it works</div>
            <h2>From application to first session.</h2>
          </div>
          <div className="steps">
            {STEPS.map((s, k) => (
              <div className="step reveal" key={k} style={{ transitionDelay: `${k * 0.08}s` }}>
                <div className="num">{s.n}</div>
                <h3>{s.h}</h3>
                <p>{s.p}</p>
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 40 }}>
            <Link className="btn btn-primary" to="/celeb-connect">Apply now →</Link>
          </div>
        </div>
      </section>
    </>
  );
}
